export default "__VITE_ASSET__Drzepbvx__"